import React from "react";

function Pagination({ setPage, current_page, total_pages }) {
  const handlePrevious = () => {
    if (current_page >= 1) {
      current_page -= 1;
      setPage(current_page);
    } else {
      setPage(current_page);
    }
  };
  const handleNext = () => {
    if (current_page !== total_pages) {
      current_page += 1;
      setPage(current_page);
    } else {
      setPage(current_page);
    }
  };
  if (total_pages >= 2) {
    return (
      <div className="pagination">
        <input
          className="btn btn-success"
          type="button"
          value="orqaga"
          onClick={handlePrevious}
        />
        <input
          className="btn btn-success"
          type="button"
          value="oldinga"
          onClick={handleNext}
        />
      </div>
    );
  } else {
    return null
  }

}

export default Pagination;
